import React from "react";

interface IStatsCardProps {
  className?: string;
  prefix: string;
  value?: number | string | undefined;
  color: string;
}
const StatsCard: React.FC<IStatsCardProps> = ({
  className,
  prefix,
  value,
  color,
}) => {
  const highlightedText = "md:text-3xl text-2xl font-semibold";
  return (
    <div
      className={`flex flex-col items-start md:gap-4 gap-2 md:p-4 p-2 rounded-lg border-2 justify-center  !border-${color} !bg-${color}  !border-opacity-50  ${className}`}
    >
      <div className="font-medium md:text-base text-xs flex-1">{prefix}</div>
      <div className={highlightedText}>{value}</div>
    </div>
  );
};

export default StatsCard;
